export default __webpack_public_path__ + "static/media/IMG1080.377e445c.jpg";